import styled from 'styled-components';

import { interactiveCard, pill } from '../../styles/mixins';

const Container = styled.div`
  ${interactiveCard}
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
`;

const Thumb = styled.div`
  position: relative;
  aspect-ratio: 4 / 5;
  background-color: var(--surface-2);
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform var(--dur-base) var(--ease-out);

  ${Container}:hover & {
    transform: scale(1.05);
  }
`;

const Badge = styled.span`
  ${pill}
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 2;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 0.4rem 0.9rem;
  background-color: ${({ free }) =>
    free ? 'var(--success-tint)' : 'var(--roxo-tint)'};
  color: ${({ free }) => (free ? 'var(--success)' : 'var(--roxo)')};
`;

const FavoriteSlot = styled.div`
  position: absolute;
  top: 0.8rem;
  right: 0.8rem;
  z-index: 2;
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1.3rem 1.4rem 1.5rem;
  flex: 1;
`;

const NameContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.8rem;
`;

const Headline = styled.p`
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--ink);
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const RatingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.3rem;
  flex: none;
`;

const Rate = styled.span`
  font-weight: 600;
  font-size: 1.3rem;
  color: var(--ink-soft);
`;

const Author = styled.p`
  font-size: 1.25rem;
  font-weight: 500;
  color: var(--ink-faint);
`;

const Categories = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin-top: 0.2rem;
`;

const Category = styled.span`
  ${pill}
  font-size: 1.1rem;
  font-weight: 600;
  padding: 0.3rem 0.9rem;
  background-color: var(--accent-tint);
  color: var(--accent-deep);
`;

const Description = styled.p`
  font-size: 1.25rem;
  color: var(--ink-faint);
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const Foot = styled.div`
  margin-top: auto;
  padding-top: 1rem;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 0.8rem;
`;

const Price = styled.p`
  font-size: 1.6rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: ${({ free }) => (free ? 'var(--success)' : 'var(--ink)')};
`;

const PreviousPrice = styled.p`
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--ink-faint);
  text-decoration: line-through;
`;

const Stat = styled.span`
  font-size: 1.2rem;
  color: var(--ink-faint);
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex: none;
  padding-bottom: 0.2rem;
`;

export {
  Author,
  Badge,
  Categories,
  Category,
  Container,
  Description,
  FavoriteSlot,
  Foot,
  Headline,
  Image,
  InfoContainer,
  NameContainer,
  PreviousPrice,
  Price,
  Rate,
  RatingContainer,
  Stat,
  Thumb,
};
